module.exports = __webpack_public_path__ + "img/fmsgpj_heise.9f65ac4e.png";